/**
 * Very thin wrapper over `sonner` so the rest of the app never imports the
 * library directly. Lets us swap to a different toast system later (e.g.
 * shadcn/ui's Toast) without a codebase-wide refactor.
 */
import { toast as sonnerToast } from 'sonner';

export const toast = {
  success(message: string, description?: string) {
    sonnerToast.success(message, description ? { description } : undefined);
  },
  error(message: string, description?: string) {
    sonnerToast.error(message, description ? { description } : undefined);
  },
  info(message: string, description?: string) {
    sonnerToast.message(message, description ? { description } : undefined);
  },
};
